// extracted by mini-css-extract-plugin
module.exports = {"root":"_2esV5","center":"_3PaB3","block":"_2rnRV","row":"_1qFvG"};